import { render, staticRenderFns } from "./districtsSubClassifier.vue?vue&type=template&id=49404278&scoped=true&"
import script from "./districtsSubClassifier.vue?vue&type=script&lang=js&"
export * from "./districtsSubClassifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49404278",
  null
  
)

export default component.exports